<template>
  <div class="modal-open">
    <div class="model-header">
      <div class="title">{{data.hotPoint.hotTitle}}</div>
      <div class="close">
        <i class="el-icon-close" @click="closeFunc"></i>
      </div>
    </div>
    <div class="model-body">
      <div class="model-full">
        <el-carousel arrow="always" :autoplay="false" v-if="data.hotPoint.hotType==3">
          <el-carousel-item v-for="item in data.physicalFilelist" :key="item.id">
            <!-- <el-image :src="item.filePath" fit="scale-down">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image> -->
            <viewer :images="data.physicalFilelist">
              <img :src="item.filePath" class="u-pic">
            </viewer>
          </el-carousel-item>
        </el-carousel>
        <el-carousel arrow="always" :autoplay="false" v-if="data.hotPoint.hotType==4">
          <el-carousel-item v-for="item in data.physicalFilelist" :key="item.id">
            <video autoplay :src="item.filePath" class="video" controls></video>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<style>
.el-carousel {
  height: 100%;
}
.el-carousel__container {
  height: 100% !important;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 50px;
}
.el-image {
  height:100%;
  width: 100%;
}

.el-carousel__indicators {
  display: none;
}
</style>
<style scoped>
.u-pic{
  cursor: pointer;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.modal-open {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000;
}

.model-header {
  height: 50px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: white;
}

.close {
  height: 50px;
  width: 50px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  font-size: 30px;
}

.title {
  width: 80%;
  margin: 0 auto;
}

.model-body {
  height: 100%;
  width: 100%;
  padding-top: 50px;
  box-sizing: border-box;
}

.model-full {
  height: 100%;
  width: 100%;
}
.video{
  width: 100%;
  height: 100%;
}
</style>
<script>
import https from '../https.js'
import Upload from '../components/upload.vue'
export default {
  name: '',
  props: {
    closeFunc: Function,
    data: Object
  },
  components: {
    Upload: Upload
  },

  data() {
    return {
      dialog: true,
      searchTxt: '',
      allcheck: false,
      page: {
        currentPage: 1,
        total: 0
      },
      chooseArr: [],
      arr: [
        // {
        //   id: "44901c67-81c4-4f30-8fea-c1d0dfc1927b",
        //   fileName: "weixin_code.png",
        //   filePath: "/Attached/2020/6/17/weixin_code.png",
        //   fileFormat: ".png",
        //   hashValue: "2020617135921",
        //   fileSize: 11917,
        //   type: null,
        //   status: 1,
        //   createTime: "2020-06-17T13:59:21.487",
        //   thumbnailUrl: null
        // }
      ]
    }
  },
  created() {},
  mounted() {
    // this.init()
    console.log(this.data)
  },
  methods: {
    init() {
      https
        .fetchPost('/api/PhysicalFile/Get', {
          type: this.type,
          pageIndex: this.page.currentPage,
          pageSize: 8
        })
        .then(res => {
          console.log(res.data)
          this.page.total = res.data.count

          for (let i = 0; i < res.data.result.length; i++) {
            res.data.result[i].check = false
          }
          this.arr = res.data.result
        })
    },
    handleCurrentChange(val) {
      this.allcheck = false
      this.chooseArr = []
      this.page.currentPage = val
      this.init()
    },
    chooseAll() {
      this.allcheck = !this.allcheck
      if (this.allcheck) {
        for (let i = 0; i < this.arr.length; i++) {
          this.arr[i].check = true
        }
        this.chooseArr = this.arr
      } else {
        for (let i = 0; i < this.arr.length; i++) {
          this.arr[i].check = false
        }
        this.chooseArr = []
      }
    },
    choose(id) {
      this.chooseArr = []
      for (let i = 0; i < this.arr.length; i++) {
        if (this.arr[i].id === id) {
          const isCheck = this.arr[i].check || false
          if (isCheck) {
            this.arr[i].check = false
          } else {
            console.log(isCheck)
            this.arr[i].check = true
            console.log(this.arr)
            this.chooseArr.push(this.arr[i])
          }
        } else {
          if (this.arr[i].check) {
            this.chooseArr.push(this.arr[i])
          }
        }
      }
      if (this.chooseArr.length === 8) {
        this.allcheck = true
      } else {
        this.allcheck = false
      }
    },
    handleClose(done) {
      this.closeFunc()
    },
    uploadPic(data) {
      console.log(data)
      this.init()
    },
    submit() {
      this.submitFunc(this.chooseArr)
      this.closeFunc()
    }
  }
}
</script>
